import PropTypes from 'prop-types'
import classNames from 'classnames'
import Card from 'components/card'
import Link from 'components/link'
import { InfoButton } from 'components/buttons'
import { ChecklistIcon } from 'components/icons'
import { checklistQuizPath } from 'lib/urls'
import css from './feed-items.scss'
import { SectionHeading } from '../../../../components/headings'

const ChecklistQuizCard = ({ ctaText, title }) => (
  <Link newWindow url={checklistQuizPath}>
    <Card className={classNames(css.iconLayout, css.checklist, 'mbxl')}>
      <div className={css.info}>
        <ChecklistIcon width={80} />
        <SectionHeading className="h3 mvl text-bold text-body">
          {title}
        </SectionHeading>
        <InfoButton pill className="mtm phxl">
          {ctaText}
        </InfoButton>
      </div>
    </Card>
  </Link>
)

ChecklistQuizCard.propTypes = {
  ctaText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default ChecklistQuizCard
